import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} anonim sohbet ana sayfası`,
    languageButtonLabel: `Dil`,
    languageModalTitle: `Bir dil seç`,
    languageModalCloseLabel: `Dil menüsünü kapat`,
  },
  languageOptions: {
    'en-US': {
      label: `İngilizce (Amerika Birleşik Devletleri)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `İngilizce (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `İngilizce (Nijerya)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `İngilizce (Singapur)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portekizce (Portekiz)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portekizce (Brezilya)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Almanca (Almanya)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Almanca (Avusturya)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Almanca (İsviçre)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `İspanyolca (İspanya)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Fransızca (Fransa)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `İtalyanca (İtalya)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Felemenkçe (Hollanda)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Lehçe (Polonya)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `İsveççe (İsveç)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danca (Danimarka)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Fince (Finlandiya)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norveççe (Norveç)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `İzlandaca (İzlanda)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japonca (Japonya)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Korece (Güney Kore)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Çince (Çin)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonca (Çin Hong Kong ÖİB)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamca (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tayca (Tayland)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Endonezce (Endonezya)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Svahili dili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hintçe (Hindistan)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengalce (Bangladeş)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi dili (Hindistan)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu dili (Hindistan)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Farsça (İran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urduca (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Pencapça (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nijerya Pidgin dili (Nijerya)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Rusça (Rusya)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arapça (Suudi Arabistan)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arapça (Birleşik Arap Emirlikleri)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arapça (Katar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Fas Arapçası (Fas)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe (Türkiye)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Bir dil seç`,
    closeLabel: `Dil menüsünü kapat`,
  },
  languageHint: (ctx) => `Hesap açmadan ${ctx.localesCount}+ dil arasında gezinebilirsin.`,
  readPagePrompt: ({languageLabel}) => `Bu sayfayı ${languageLabel} dilinde oku.`,
};
